export default {"src":"/_next/static/media/image-icon.c7c9d0c9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};